import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { createSlice } from "@reduxjs/toolkit";
var initialState = {
    data: null,
    isFetching: false,
    isError: false
};
var getProductDetail = createSlice({
    name: "getProductDetail",
    initialState: initialState,
    reducers: {
        fetchData: function(state) {
            state.isFetching = true;
            state.data = null;
            state.isError = false;
        },
        fetchDataSuccess: function(state, action) {
            return _object_spread_props(_object_spread({}, state), {
                isFetching: false,
                data: action.payload
            });
        },
        fetchDataFailure: function(state) {
            return _object_spread_props(_object_spread({}, state), {
                isFetching: false,
                isError: true
            });
        },
        resetState: function() {
            return initialState;
        }
    }
});
var _getProductDetail_actions = getProductDetail.actions;
export var fetchData = _getProductDetail_actions.fetchData, fetchDataSuccess = _getProductDetail_actions.fetchDataSuccess, fetchDataFailure = _getProductDetail_actions.fetchDataFailure, resetState = _getProductDetail_actions.resetState;
export default getProductDetail.reducer;
